import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

export function initSentry(): void {
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: "production",
    enabled: process.env.NODE_ENV === "production",
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: 0,
    sendDefaultPii: false,
    // Rumore: chunk dopo deploy, estensioni (Honey/Chrome), PiP Safari.
    ignoreErrors: [
      "ChunkLoadError",
      "Loading chunk",
      "Loading CSS chunk",
      "Unexpected token '<'",
      "Object Not Found Matching Id",
      "Non-Error promise rejection captured",
      "The request is not triggered by a user activation",
      "UnavailableError",
    ],
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /safari-extension:/i,
      /safari-web-extension:/i,
      /Honey\.safariextension/i,
    ],
  });
}

export { Sentry };
